import React, { memo, useState, useMemo } from 'react'

import { Flex, Box } from '../../components/FlexBox'
import Text from '../../components/Text'
import Input from '../../components/Input'
import Select from '../../components/Select'
import ButtonRaw from '../../components/ButtonRaw'
import { DeleteIcon } from '../../components/Icons'
import CircularProgress from '../../components/CircularProgress'

import { useQuery } from '../../hooks/useApollo'
import { LIST } from './Gqls'

import BASE_API from '../../constants/baseApi'
import AUTH_TOKEN from '../../constants/authToken'

const filter = (patients, search, sortBy) => {
  const filtered = patients
    .filter(item => {
      let condition = true
      if (condition) condition = search ? item.name.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '').includes(search.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')) : condition
      return condition      
    })
  
  let ordered = filtered.sort((a, b) => {
    if (a[sortBy] < b[sortBy]) return -1
    if (a[sortBy] > b[sortBy]) return 1
    return 0
  })

  if(sortBy == '-name') {
    ordered = filtered.sort((a, b) => {
      if (b['name'] < a['name']) return -1
      if (b['name'] > a['name']) return 1
      return 0
    })
  }
  
  return ordered
}

const List = memo(({ patients, navigate }) => {

  const [search, setSearch] = useState('')
  const [sortBy, setSortBy] = useState('name') // id 

  const filtered = useMemo(() => filter(patients, search, sortBy), [patients, search, sortBy])

  const handleDelete = async (e, id) => {
    e.stopPropagation()
    if (window.confirm('Você tem certeza que deseja excluir este paciente?')) {
      const response = await fetch(`${BASE_API}/share/doctor/?patientId=${id}`, { method: 'DELETE', headers: { Authorization:  `token ${localStorage.getItem(AUTH_TOKEN)}` }})
      const data = await response.json()
      console.log('data', data)
      window.location.href = `/pacientes`
    }
  }

  return (
    <Box>

      <Box mb={3}>
        {/*<Text fw={600}>xx</Text>*/}
      </Box>

      <Flex>
        <Box mr={3}>
          <Input placeholder='Buscar...' value={search} onChange={e => setSearch(e.target.value)} />
        </Box>
        <Box>
          <Select value={sortBy} onChange={e => setSortBy(e.target.value)}>
            <option value='name'>Ordenado por Nome (A - Z)</option>
            <option value='-name'>Ordenado por Nome (Z - A)</option>
            {/*<option value='id'>Ordenado por Data de Criação</option>*/}
          </Select>
        </Box>
      </Flex>

      {filtered.map(item => (
        <Flex jc='space-between' ai='center' key={item.id} onClick={() => navigate(`/pacientes/${item.id}`)} cursor='pointer' p={3} style={{borderBottom: '1px solid lightgrey'}}>
          <Box>
            {item.name}
          </Box>
          <Box ml={3}>
            {/* <Text fs={12}></Text> */}
            <ButtonRaw onClick={e => handleDelete(e, item.id)}><DeleteIcon /></ButtonRaw>
          </Box>
        </Flex>
      ))}
    </Box>
  )
})

export default memo(props => {
  const { data, error, loading } = useQuery(LIST)
  if (error) return `Erro! ${error.message}`
  if (!data || loading) return <CircularProgress />
  console.log({data})
  return <List {...props} patients={data.patients} />
})
